import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollText } from "lucide-react";

const ACTION_TONE = {
  CREATE: "bg-emerald-100 text-emerald-800", UPDATE: "bg-blue-100 text-blue-800",
  UPLOAD: "bg-teal-100 text-teal-800", ARCHIVE: "bg-slate-200 text-slate-700",
  STATUS_CHANGE: "bg-amber-100 text-amber-800", LOGIN: "bg-slate-100 text-slate-600",
  LOGOUT: "bg-slate-100 text-slate-600", RESET_PASSWORD: "bg-red-100 text-red-800",
};

export default function AuditLogs() {
  const { data, isLoading } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit-logs")).data });

  return (
    <div>
      <PageHeader overline="Governance" title="Audit Trail" icon={ScrollText}
        subtitle="Immutable record of every critical action — user, role, timestamp, before & after." />
      {isLoading ? <Loading /> : (
        <Card className="border-slate-200 shadow-none overflow-hidden">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead className="overline text-slate-500">Timestamp</TableHead>
              <TableHead className="overline text-slate-500">User</TableHead>
              <TableHead className="overline text-slate-500">Action</TableHead>
              <TableHead className="overline text-slate-500">Module</TableHead>
              <TableHead className="overline text-slate-500">Reason / Detail</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {(data || []).length === 0 ? (
                <TableRow><TableCell colSpan={5} className="text-center text-slate-400 py-10">No audit records yet.</TableCell></TableRow>
              ) : data.map((l) => (
                <TableRow key={l.id} className="table-row-i" data-testid={`audit-row-${l.id}`}>
                  <TableCell className="text-slate-500 text-xs font-mono-i whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</TableCell>
                  <TableCell className="text-navy text-sm">{l.user_email}<span className="block text-[11px] text-slate-400">{l.role}</span></TableCell>
                  <TableCell><span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${ACTION_TONE[l.action] || "bg-slate-100 text-slate-700"}`}>{l.action}</span></TableCell>
                  <TableCell className="text-slate-600 text-sm">{l.module}</TableCell>
                  <TableCell className="text-slate-500 text-xs min-w-[200px] max-w-[340px] whitespace-normal break-words">{l.reason || (l.new_value ? JSON.stringify(l.new_value) : "—")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
